import {
  PROCESSING_STATUS_LABEL,
  HUMAN_INPUT_REQUIRED_STATUS_LABEL,
  COMPLETE_STATUS_LABEL,
  REVIEWED_STATUS_LABEL,
  ERROR_STATUS,
} from '@utils/constants';

export interface VendorDataStatusFilterOption {
  label: string;
  // review_queue_item_status values on the backend that this option's badge text represents -
  // see DocumentStatusBadgeComponent.statusTranslationLookup, which shows both
  // HUMAN_INPUT_REQUIRED_STATUS_LABEL and REVIEWED_STATUS_LABEL as "User Input Required".
  reviewQueueItemStatuses: string[];
}

// The status-text buckets app-doc-status-badge actually renders for a vendor data record.
export const VENDOR_DATA_STATUS_FILTER_OPTIONS: VendorDataStatusFilterOption[] = [
  { label: PROCESSING_STATUS_LABEL, reviewQueueItemStatuses: [PROCESSING_STATUS_LABEL] },
  { label: 'User Input Required', reviewQueueItemStatuses: [HUMAN_INPUT_REQUIRED_STATUS_LABEL, REVIEWED_STATUS_LABEL] },
  { label: COMPLETE_STATUS_LABEL, reviewQueueItemStatuses: [COMPLETE_STATUS_LABEL] },
  { label: 'Error', reviewQueueItemStatuses: [ERROR_STATUS] },
];

export class VendorDataFilter {
  year: string | null = null;
  reportingInterval: string | null = null;
  classification: string | null = null;
  status: string | null = null;

  isEmptySearch(): boolean {
    return Object.keys(this).every(attrKey => !this[attrKey]);
  }
}
